/**
 * 活动服务
 */
"use strict";
angular.module("activityCalendarServiceModule", ["personalLibraryActivityAddFieldModule"]).
factory("activityCalendarService", ["$q", "$modal", function($q, $modal) {
    return {
        /**
         * [addFied description]  活动稿新增场次
         * @param {[array]} selectedDays   [description] 选中的日期
         * @param {[array]} [alreadySetFields] [description] 已经被设定的场次
         */
        addField: function(selectedDays, alreadySetFields) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/submissionManage/personalLibrary/activity/service/addField/addField_tpl.html",
                windowClass: "personalLibrary-activity-addField",
                backdrop: false,
                controller: "personalLibraryActivityAddFieldCtrl",
                resolve: {
                    selectedDays: function() {
                        return selectedDays;
                    },
                    alreadySetFields: function() {
                        return alreadySetFields;
                    }
                }
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        },
    };
}]);